import React from 'react'
import '../App.css'
import Footer from '../Footer'
import './Team.css'

export default function Team() {
    return (
        <>
        <h1 className='meet-the-team'>ABOUT US</h1>
        <div className='team__section'>
            <div className='team-rightColumnStyle'>
                <img
                    src="/images/brokerMan2.jpg"
                    alt="Man in suit holding a tablet"
                    className='team-hero-about-img'
                />
            </div>
            <div className='team-leftColumnStyle'>
                <h1 className='team-headingStyle'>SHAWN JALALI</h1>
                <p className='team-licenseInfo'>
                    Real Mortgage Associates<br />
                    RMA #10464<br />
                    License Number: M11000580
                </p>
                <p className='team-paragraphStyle'>
                    With over 14 years of experience in the mortgage industry, 
                    Shawn Jalali is dedicated to making the home financing process simple and stress-free. 
                    He understands that securing a mortgage is one of the biggest financial decisions you'll make, 
                    and he's committed to finding the best solution tailored to your unique needs.
                </p>
                <p className='team-paragraphStyleBtn'>
                    As a mortgage agent, Shawn Jalali works with a wide network of lenders to offer 
                    competitive rates and flexible loan options. Whether you're a first-time homebuyer, refinancing, 
                    or investing in property, he provides expert guidance every step of the way. 
                    His goal is to take the confusion out of the mortgage process, 
                    ensuring you feel confident and informed from start to finish.
                </p>
            </div>
        </div>
        <Footer/>
        </>
    )
}